import { createContext, ReactNode, useContext } from 'react';

import { PublicEnvironmentConfig } from '../types/publicEnvironmentConfig';

const EnvConfigContext = createContext<PublicEnvironmentConfig | undefined>(undefined);

export const EnvConfigProvider = ({
  children,
  config,
}: {
  children: ReactNode;
  config: PublicEnvironmentConfig;
}) => {
  return <EnvConfigContext.Provider value={config}>{children}</EnvConfigContext.Provider>;
};

export const useEnvConfig = (): PublicEnvironmentConfig => {
  const context = useContext(EnvConfigContext);
  if (!context) {
    throw new Error('useEnvConfig must be used within an EnvConfigProvider');
  }
  return context;
};
